<div class="subBlockContainer" id="associatetenant">
  <div class="subBlockContent">
    <child-header [title]="title" (closeEvent)="close()"></child-header>
    <div class="child-header">
      <div class="inner-subBlock-wrapper"></div>
      <div class="container">
        <div class="row">
          <div [formGroup]="userFormGroup" class="col-md-12">
            <div class="userinfo">
              <mat-form-field [floatLabel]="'always'">
                <input matInput class="domainValidate" formControlName="domain" placeholder="DOMAIN"
                  (blur)="getTenantIdByDomain()" requried>
                <mat-icon matSuffix class="usernameicon" placement="left"
                  matTooltip="Tenant Domain from Microsoft, ex. mydomain.onmicrosoft.com">info</mat-icon>
              </mat-form-field>
              <mat-form-field [floatLabel]="'always'">
                <input matInput class="companyIdValidate" formControlName="companyId" placeholder="COMPANY ID" required>
                <mat-icon matSuffix class="usernameicon" placement="left"
                  matTooltip="Microsoft Customer GUID, automatically populated once the above domain verified">info
                </mat-icon>
              </mat-form-field>
              <mat-form-field [floatLabel]="'always'">
                <input matInput class="associateCompanyNameValidate" placeholder="COMPANY NAME"
                  formControlName="associateCompanyName">
              </mat-form-field>
              <mat-form-field [floatLabel]="'always'">
                <input matInput class="associateEmailValidate" placeholder="EMAIL" formControlName="associateEmail"
                  required>
                <mat-icon matSuffix class="usernameicon" placement="left"
                  matTooltip="Link to Microsoft for association will be sent to this email address">info</mat-icon>
              </mat-form-field>
              <mat-checkbox formControlName="associateCancelCC" style="display: none;">CANCEL MY CREDIT CARD ASSOCIATED WITH MICROSOFT
              </mat-checkbox>
            </div>
          </div>
        </div>
        <!-- <div class="row" *ngIf="tenantId != ''">
          <div class="userinfo col-md-12" *ngIf="companyCode==='T01' || companyCode==='1'">
            <div class="payment-title">Payment Method</div>
            <div id="list-payment">
              <div class="noData-wrapper" *ngIf="!paymentList?.length">
                <div>
                  <img src="../images/new_ui/no-wallet.png">
                </div>
                <div class="noData-label">Your digital wallet is empty.</div>
                <div class="button-center">
                  <button id="addPaymentBtn" class="button button-red button-large"
                    (click)="navigateToDigitalWallet()">Create new</button>
                </div>
              </div>

              <ng-container *ngIf="paymentList?.length">
                <div class="row margin-top-30 dropdownBox">
                  <div class="col-sm">
                    <label class="po-label">Select a payment from your wallet</label><br />
                    <button class="button button-red button-mid reset-payment" (click)="resetPayment()">Reset Payment
                      Option</button>
                    <mat-form-field>
                      <mat-select [(value)]="selectedPayment" (change)="selectPaymentMethod();">
                        <mat-option value="{{payment.value}}" *ngFor="let payment of paymentList">{{payment.text}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div> -->
      </div>
      <div class="associate-button">
        <button
          class="button button-red button-large"
          [disabled]="!currentUserModel?.hasAdminAccess && !currentUserModel?.hasPurchaseAccess"
          [matTooltipDisabled]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"	
          matTooltip="Requires Purchasing Permissions"
          (click)="associateEndUser()"
        >Associate</button>
      </div>
      <loading-screen *ngIf="!loadContent" backDropWidth="400" [isChildLoader]="true" [showBlurTable]="false">
      </loading-screen>
    </div>
  </div>
</div>